import { GenericResponseModel, LoginRequest } from "../dataModel/authModels";
import { AppyDocPostObj, DocumentRequestObj } from "../dataModel/documentModels";
import { ApiRoutes } from "./apiConfig/apiEdndpoints";
import { customAxios } from "./apiConfig/useExPressApi";

export const doc = {
    getSignedDoc: (data:DocumentRequestObj) => {
      return customAxios.post<any, GenericResponseModel>(`${ApiRoutes.GET_SIGNED_DOC}`,data);
     },
     getPendingDoc: (data:DocumentRequestObj) => {
      return customAxios.post<any, GenericResponseModel>(`${ApiRoutes.GET_PENDING_DOC}`,data)
     },
     getDocViewUrl: () => {
      return customAxios.get<any, GenericResponseModel>(`${ApiRoutes.GET_VIEW_DOC_URI}`)
     },
     validatePins: (object:string) => {
      return customAxios.get<any, GenericResponseModel>(`${ApiRoutes.VALIDATE_PIN}?${object}`)
     },

     applySign: (object:AppyDocPostObj) => {
      return customAxios.post<any, GenericResponseModel>(`${ApiRoutes.APPLY_SIGNATURE}`,object)
     },
   
     
}